import { render, staticRenderFns } from "./VisualisationN.vue?vue&type=template&id=2bb2d958&scoped=true&"
import script from "./VisualisationN.vue?vue&type=script&lang=js&"
export * from "./VisualisationN.vue?vue&type=script&lang=js&"
import style0 from "./VisualisationN.vue?vue&type=style&index=0&id=2bb2d958&lang=scss&scoped=true&"
import style1 from "./VisualisationN.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2d958",
  null
  
)

export default component.exports